import { register } from 'register-service-worker'
import Config from '../config'

// Clear all old caches on app load
if ('caches' in window) {
  caches.keys().then(cacheNames => {
    cacheNames.forEach(cacheName => {
      // Delete all caches that are not current version
      if (cacheName !== 'v2') {
        caches.delete(cacheName)
      }
    })
  })
}

if (process.env.NODE_ENV === 'production' && Config.productionPlatform === 'web') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // console.log(
      //   'App is being served from cache by a service worker.\n'
      //   + 'For more details, visit https://goo.gl/AFskqB',
      // )
    },
    registered() {
      // console.log('Service worker has been registered.')
    },
    cached() {
      // console.log('Content has been cached for offline use.')
    },
    updatefound() {
      // console.log('New content is downloading.')
    },
    updated() {
      // نسخهٔ جدید نصب شد؛ صفحه را یک‌بار خودکار ریلود کن تا کاربر بدون هارد-ریفرش بیلد تازه را بگیرد
      if (!window.__reloadingForSwUpdate) {
        window.__reloadingForSwUpdate = true
        window.location.reload()
      }
    },
    offline() {
      // console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      // console.error('Error during service worker registration:', error)
    },
  })
}
